var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('b-img',{staticClass:"w-auto mt-5 mb-2",attrs:{"center":"","src":require("@assets/images/xactus_logo.png"),"fluid-grow":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }